declare const __APP_BUILD_ID__: string

export const APP_BUILD_ID = __APP_BUILD_ID__

export async function fetchRemoteVersion(): Promise<string | null> {
  try {
    const response = await fetch('/version.json', { cache: 'no-store' })
    if (!response.ok) return null
    const data = (await response.json()) as { version: string }
    return data.version
  } catch {
    return null
  }
}

export function isChunkLoadError(error: unknown): boolean {
  if (error instanceof Error) {
    return (
      error.message.includes('Failed to fetch dynamically imported module') ||
      error.message.includes('Loading chunk') ||
      error.message.includes('is not a valid JavaScript MIME type')
    )
  }
  return false
}
